export const ActionTypes = {
  FETCH_ALL: 'services/factoryAreas/fetch_all',
  FETCH_ALL_SUCCESS: 'services/factoryAreas/fetch_all_success',
  SET_LOADER_STATUS: 'services/factoryAreas/set_loader_status',
  SET_ALL: 'services/factoryAreas/set_all',
  ADD_OR_UPDATE_FACTORY_AREA: 'services/factoryAreas/add_or_update_factoryArea',
  DELETE_FACTORY_AREA: 'services/factoryAreas/delete_factoryArea',
  FETCH_ALL_FACTORY_AREAS: 'services/factoryAreas/fetch_all_factory_Areas',
};

const fetchAll = ({ factoryAreaParams }) => ({
  factoryAreaParams,
  type: ActionTypes.FETCH_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allFactoryArea }) => ({
  allFactoryArea,
  type: ActionTypes.SET_ALL,
});

const addorUpdateFactoryArea = ({ factoryAreaData, actionName, factoryAreaParams }) => ({
  factoryAreaData,
  actionName,
  factoryAreaParams,
  type: ActionTypes.ADD_OR_UPDATE_FACTORY_AREA,
});

const deleteFactoryArea = ({ id, factoryAreaParams }) => ({
  id,
  factoryAreaParams,
  type: ActionTypes.DELETE_FACTORY_AREA,
});

const fetchAllFactoryAreas = () => ({
  type: ActionTypes.FETCH_ALL_FACTORY_AREAS,
});

export default {
  fetchAll,
  setAll,
  setLoader,
  addorUpdateFactoryArea,
  deleteFactoryArea,
  fetchAllFactoryAreas,
};
